import { freeUserUpgradeStep } from '../utils';

export const myTeamBusinessFreeTour = {
  tourKey: 'my_team_business_free',
  conditions: {
    orgTypes: ['business'],
    userTypes: ['admin'],
    plans: ['free'],
  },
  steps: [
    {
      title: 'tours.my-team-business-free.welcome.title',
      content: 'tours.my-team-business-free.welcome.content',
      placement: 'center',
    },
    {
      target: '[data-tour="my-team-invite"]',
      title: 'tours.my-team-business-free.invite.title',
      content: 'tours.my-team-business-free.invite.content',
      placement: 'bottom',
    },
    {
      target: '[data-tour="my-team-invite-link"]',
      title: 'tours.my-team-business-free.invite-link.title',
      content: 'tours.my-team-business-free.invite-link.content',
      placement: 'bottom',
    },
    freeUserUpgradeStep,
  ],
};
